import React from 'react';
import BaseIcon from './BaseIcon';


const PlusIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M9,9 L9,11.2 C9,11.6418278 8.55228475,12 8,12 C7.44771525,12 7,11.6418278 7,11.2 L7,9 L4.8,9 C4.3581722,9 4,8.55228475 4,8 C4,7.44771525 4.3581722,7 4.8,7 L7,7 L7,4.8 C7,4.3581722 7.44771525,4 8,4 C8.55228475,4 9,4.3581722 9,4.8 L9,7 L11.2,7 C11.6418278,7 12,7.44771525 12,8 C12,8.55228475 11.6418278,9 11.2,9 L9,9 Z M8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 Z M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z" fillRule="nonzero" />
    </g>
  </BaseIcon>
);

export default PlusIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/PlusIcon.jsx